module.exports = __webpack_public_path__ + "img/piece-complete-7.324cf4de.svg";